import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const PageShape = ({ width, height, fillColor, style }: BaseSVGType) => {
  return (
    <svg
      fill={fillColor}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={width}
      height={height}
      viewBox="0 0 49.167 49.167"
    >
      <g>
        <path
          d="M31.667,13.167c-2.209,0-4-1.791-4-4V0H14.833c-4.418,0-8,3.582-8,8v33.167c0,4.418,3.582,8,8,8h19.5c4.419,0,8-3.582,8-8
		v-28H31.667z M24.583,32.042H14.75c-0.829,0-1.5-0.672-1.5-1.5s0.671-1.5,1.5-1.5h9.833c0.828,0,1.5,0.672,1.5,1.5
		S25.412,32.042,24.583,32.042z M34.125,26.167H14.75c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h19.375
		c0.828,0,1.5,0.671,1.5,1.5S34.954,26.167,34.125,26.167z M34.125,20.292H14.75c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5
		h19.375c0.828,0,1.5,0.671,1.5,1.5S34.954,20.292,34.125,20.292z M30.459,7.776V2.847c0-1.215,0.751-2.251,1.813-2.678l9.77,7.815
		c-0.107,1.498-1.346,2.683-2.87,2.683h-5.821C31.753,10.667,30.459,9.373,30.459,7.776z"
        />
      </g>
    </svg>
  );
};

export default PageShape;
